var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-error"},[_c('PreviewErrorSm',{staticClass:"preview-error__img preview-error__img--sm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }